/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useState,useEffect,useRef } from 'react'
import { Link,useNavigate,useLocation,useHistory ,useParams,useSearchParams,Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';

import moment from 'moment'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import Breadcrumb from '../../../component/Breadcrumb'
import Express from '../FormComponent/Express';
import Procedures from '../FormComponent/Procedures';
import PaymentSideBlock from '../FormComponent/PaymentSideBlock';
import { CessionPartsSociales} from '../adsFormComp';
import FormSummary from '../FormSummary';
import CompleteAddress from '../CompleteAddress';
import PaymentForm from '../PaymentForm'
import PaymentSecond from '../PaymentSecond'
import Footer from '../../../component/Footer';
import FormSuccess from '../FormSuccess';
import axios from 'axios';
import { announceActions,alertActions } from '../../../_actions';
import ToastMessageComp from '../../../component/ToastMessageComp';
import { announceConstants } from '../../../_constants';
import PageLoaderComp from '../../../component/pageLoaderComp';

import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';
import { isValidEmail,isNumericValue,isValidPhoneNumber} from '../../../_helpers';
import { Ads_fullname } from '../../../_helpers/ads_fullname';
import { getDetailsBySiren } from '../../../_helpers';

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`, {
  locale: 'fr' // Set the locale to French
});

export function CessionPartsSocialesStepperForm() {
 
  const appearance = {
    theme: 'stripe',
  };
 
  const [loading, setLoading] = useState(false);
  const [loadingFullpage, setLoadingFullpage] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [options, setOptions] = useState( {
    clientSecret,
    appearance,
  });

  const [queryParameters] = useSearchParams()
  const childRef = useRef();
  const announceIdRef = useRef("");
  const steps = ['Remplir le formulaire', 'Visualiser le récapitulatif', 'Adresse de facturation', 'Procéder au paiement', 'succès'];
  const alert = useSelector(state => state.alert);
  const dispatch = useDispatch(); 
  const location = useLocation(); 
  let navigate = useNavigate();
  let { ads,adsname,id } = useParams();
  
  const currentUser = useSelector(state => state.authentication.user);
  const announceData = useSelector(state => state.announce.announce);
  const [isCheckedSerenity,setIscheckedSerenity]=useState(false)
  const [is_general_conditions_sale,setis_general_conditions_sale]=useState(false)
  const [general_conditions_sale_msg,setgeneral_conditions_sale_msg]=useState("")
  const [announceDetails,setAnnounceDetails]=useState("")
  const [AdsFullName,setAdsFullName]=useState("")
  const [La_gerance, setLa_gerance] = useState([{
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    Personne_typecendant:"",
    civilite_cendant:"",
    nom_cendant:"",
    prenom_cendant:"",
    resident_etranger_physique_morale:"Non",
    rcs_cendant:"",
    denomination_morale:"",
    forme_juridique_morale:"",
    capital_morale:"",
    representation_morale:"",
    representation_nom_morale:"",
    representation_prenom_morale:"",
    address_morale:"",
    adresssuite_morale:"",
    code_postal_morale:"",
    ville_morale:"",
    ville_moraleArr:[],
    ville_id_morale:"",
    greffe_morale:"",
    pays_morale:"",
  }]);
  const [Benefiser, setBenefiser] = useState([{
    user_id:currentUser&&currentUser.data?currentUser.data.id:"",
    index:0,
    Personne_benefiser:"",
    civilite_physique_benefiser:"",
    nom_physique_benefiser:"",
    prenom_physique_benefiser:"",
    resident_etranger_physique_benefiser:"Non",
    rcs_benefiser:"",
    denomination_benefiser:"",
    forme_jurdique_benefiser:"",
    capital_benefiser:"",
    representation_civilite_benefiser:"",
    representation_nom_benefiser:"",
    representation_prenom_benefiser:"",
    adresse_benefiser:"",
    adresse_suite_benefiser:"",
    code_postal_benefiser:"",
    ville_benefiser:"",
    ville_benefiserArr:[],
    ville_id_benefiser:"",
    greffe_benefiser:"",
    pays_benefiser:"",
  }]);
 
  const [formData,setFormData]= useState({
    "announce_id":id?id:"",title:(ads.split("-")).join(" "),add_type_full:AdsFullName, add_type:adsname?adsname:"",form_type:adsname?adsname:"",type_perdecision_acte:"",date_typeag:"",date_type_effet:"",rcs_societe:"",denomination_societe:"",forme_juridique_societe:"",forme_juridique_societeType:"",capital_societe:"",address_societe:"",address_suite_societe:"",code_postal:"",ville:"",villeArr:[],ville_id:"",greffe:"",modification:"",fonction:"" ,La_gerance:La_gerance,Benefiser:Benefiser});

  const [isSubmitted, setSubmitted] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [successful, setSuccessful] = useState(false);
  const [userSelectedAddress, setUserSelectedAddress] = useState({
    "announce_id":id,
    "user_id":currentUser && currentUser.data?currentUser.data.id:"",
    "delivery_address":currentUser && currentUser.user_address?currentUser.user_address[0]:"",
    "shipping_address":currentUser && currentUser.user_address?currentUser.user_address[0]:"",
    "email":currentUser && currentUser.data?currentUser.data.email:"",
    "telephone":currentUser && currentUser.data?currentUser.data.telephone:"",
    "billing_address_type":"account_address",
    "billing_address_denomination":currentUser && currentUser.data?currentUser.data.raisosociale:"",
    "billing_address_civility":currentUser && currentUser.data?currentUser.data.civil:"",
    "billing_address_nom":currentUser && currentUser.data?currentUser.data.firstname:"",
    "billing_address_prenom":currentUser && currentUser.data?currentUser.data.lastname:"",
    "billing_address_address":currentUser && currentUser.data?currentUser.data.adresse:"",
    "billing_address_code_postal":currentUser && currentUser.data?currentUser.data.postalcode:"",
    "billing_address_ville":currentUser && currentUser.data?currentUser.data.ville:"",
    "billing_address_ville_id":currentUser && currentUser.data?currentUser.data.ville_id:"",
    "billing_address_villeArr":currentUser && currentUser.data&& currentUser.data.villeArr?JSON.parse(currentUser.data.villeArr):[],
  });
  
  const [fromAdmin,setFromAdmin]=useState(localStorage.getItem("fromAdmin"));
  const [payamentPrice,sePayamentPrice]=useState(0);
  const [paymentData,setPaymentData]=useState("");
  useEffect(() => {if(id){setFormData({...formData,announce_id: id});}}, [id])
  useEffect(() => {
    window.scrollTo(0, 0)
    setAdsFullName(Ads_fullname(adsname));
    if(id){
      let announce = {
        "data":[],
        "announce_id":id 
      }
      dispatch({ type: announceConstants.CREATE_SUCCESS, announce});
    }
    if(localStorage.getItem("activeStep")){
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }
      setActiveStep(parseInt(localStorage.getItem("activeStep")))
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped); 
    }
    if(!queryParameters.get("activstep") && id){
      // setActiveStep(1);
      getAnnounceDetails(id);
    }
    
  }, [])
  
  useEffect(() => { 
    if(announceDetails){
      let announceDetailsGet = announceDetails.data;
      announceDetailsGet.votre_annonce_json.announce_id=id?id:"";
      announceDetailsGet.votre_annonce_json.title=ads?(ads.split("-")).join(" "):"";
      setFormData(announceDetailsGet.votre_annonce_json);
    }
  }, [announceDetails])

  useEffect(() => {   
    if(activeStep ===3 && payamentPrice >0){
      fetch(process.env.REACT_APP_API_URL+`api/create-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [],announce_id: id,price:payamentPrice,paymentData:paymentData.data.votre_annonce}),
      })
        .then((res) => res.json())
        .then((data) => {
          setClientSecret(data.clientSecret);
          let clientSecret = data.clientSecret
          setOptions({clientSecret,appearance})
        });
    }    
    
  }, [activeStep,payamentPrice])

  useEffect(() => {  
    if(paymentData && paymentData.data){
      sePayamentPrice(parseFloat(parseFloat(paymentData.data.total)+(isCheckedSerenity?118.80:0)).toFixed(2))
    }
    
  }, [isCheckedSerenity,paymentData])

  useEffect(() => {  
    if(queryParameters.get("activstep")  && id && ( (queryParameters.get("payment_intent") && queryParameters.get("payment_intent_client_secret")) || (currentUser && currentUser.UserProDetails && currentUser.UserProDetails.details && currentUser.UserProDetails.details.payment_plan !== null && currentUser.UserProDetails.details.payment_plan.includes("monthly")) )){
      const getDetails = async () => {
        const details_response = await getAnnounceDetails(id);
        if(details_response.success){
          if(parseInt(details_response.data.data.status) === 1 || parseInt(details_response.data.data.status) === 2){
            let data = {
              "announce_id":id,
              "payment_order_id":moment().format("DDMMY")+"_"+id.padStart(8, '0'),
              "invoice_number":moment().format("DDMMY")+"_"+id.padStart(8, '0'),
              "invoice_date":moment().format("DD-MM-Y"),
              "date_payment":moment().format("DD-MM-Y"),
              "payment_intent":queryParameters.get("payment_intent"),
              "payment_price":details_response.data.data.total,
              "payment_intent_client_secret":queryParameters.get("payment_intent_client_secret"),
            }
            const update_response = await updateAnnouncePayment(data);
            
          }
        }
      };    
      getDetails();
    }
    
  }, [queryParameters.get("activstep"),queryParameters.get("payment_intent"),queryParameters.get("payment_intent_client_secret")])

  useEffect(() => {
    const getData = setTimeout(async() => {
      setFormData(formData => ({ ...formData, ["ville"]: "",["ville_id"]: "",["villeArr"]:[],["greffe"]: ""  }));  
      if(formData.code_postal.length>0){
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${formData.code_postal}`);        
        if( response.data &&  response.data.data){
          setFormData(formData => ({ ...formData, ["ville"]: response.data.data.city,["villeArr"]:response.data.data.cityArr,["ville_id"]: response.data.data.id,["greffe"]: response.data.data.area  }));
        }
      }      
    }, 1000)
    return () => clearTimeout(getData);
  }, [formData.code_postal])
  
  
  
  async function getCityFromPostalType(name,value){  
     
    const getCity = setTimeout(async() => {      
      
      /* if(name === "code_postal_la_grance"){       
        setFormData(formData => ({ ...formData, ["ville_la_grance"]: "",["ville_la_grance_id"]: "" }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){ 
            setFormData(formData => ({ ...formData, ["ville_la_grance"]: response.data.data.city,["ville_la_grance_id"]: response.data.data.id }));
          }
        }  
      } */
       
    }, 1000);
    return () => clearTimeout(getCity);
  }
  async function handleChangeAddForm(e,index,type="lagrance") {
    let { name, value } = e.target;
    if(type === "lagrance"){
      let values = [...La_gerance];
      if(name == "ville_id_morale"){        
        let cityArrFilter = values[index].ville_moraleArr.filter((val,i)=>val.id==value);
        values[index]["ville_morale"] = cityArrFilter[0].city;
        values[index]["ville_id_morale"] = value;
        values[index][name] = value;
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));

      }else{
        
        values[index][name] = value;
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
      }
      if(name ==="code_postal_morale"){
        await getCityFromPostal(name,value,index);
      }
      if(name === "rcs_cendant"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
     /*  let values = [...La_gerance];
      values[index][name] = value;
      setLa_gerance(values);
      setFormData(formData => ({ ...formData, ["La_gerance"]: values })); */

    }else if(type=== "Benefiser"){
      let values = [...Benefiser]; 
      if(name == "ville_id_benefiser"){        
        let cityArrFilter = values[index].ville_benefiserArr.filter((val,i)=>val.id==value);
        values[index]["ville_benefiser"] = cityArrFilter[0].city;
        values[index]["ville_id_benefiser"] = value;
        setBenefiser(values);
        setFormData(formData => ({ ...formData, ["Benefiser"]: values }));

      }else{  
        values[index][name] = value;
        setBenefiser(values);
        setFormData(formData => ({ ...formData, ["Benefiser"]: values }));
      }
      if(name ==="code_postal_benefiser"){
        await getCityFromPostal(name,value,index);
      }
      if(name === "rcs_benefiser"){
        await getSirenDetailsBySiren(name,value,index,type);
      }
      
    }
    
  }
  async function getSirenDetailsBySiren(name,value,index,type="lagrance"){
   
    const getSiren = setTimeout(async() => {
      if(type=== "lagrance"){
        let values = [...La_gerance];
        // values[index]["rcs_cendant"] = value;
        values[index]["denomination_morale"] = "";
        values[index]["forme_juridique_morale"] = "";
        values[index]["capital_morale"] = "";
        values[index]["address_morale"] = "";
        values[index]["code_postallagrance"] = "";
        values[index]["ville_morale"] = "";
        values[index]["ville_moraleArr"] =[];
        values[index]["ville_id_morale"] = "";
        values[index]["greffe_morale"] = "";
        
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));     
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          // values[index]["rcs_cendant"] = value;      
          values[index]["denomination_morale"] = getDetails.denomination;
          values[index]["forme_juridique_morale"] = getDetails.forme_juridique;
          values[index]["capital_morale"] = getDetails.capital_social;
          values[index]["address_morale"] = getDetails.adresse_rcs;
          values[index]["code_postallagrance"] = getDetails.code_postal;
          values[index]["ville_morale"] = getDetails.ville;
          values[index]["ville_moraleArr"] =getDetails.cityArr;
          values[index]["ville_id_morale"] = getDetails.ville_id;
          values[index]["greffe_morale"] = getDetails.area;
          setLa_gerance(values);
          setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
        }      
      }
      if(type=== "Benefiser"){
        let values = [...Benefiser];
        // values[index]["rcs_benefiser"] = value;
        values[index]["denomination_benefiser"] = "";
        values[index]["forme_jurdique_benefiser"] = "";
        values[index]["capital_benefiser"] = "";
        values[index]["adresse_benefiser"] = "";
        values[index]["code_postal_benefiser"] = "";
        values[index]["ville_benefiser"] = "";
        values[index]["ville_benefiserArr"] =[];
        values[index]["ville_id_benefiser"] = "";
        values[index]["greffe_benefiser"] = "";
        
        setBenefiser(values);
        setFormData(formData => ({ ...formData, ["Benefiser"]: values }));     
        if(value.length>0){
          
          let getDetails = await getDetailsBySiren(value);    
          // values[index]["rcs_benefiser"] = value;      
          values[index]["denomination_benefiser"] = getDetails.denomination;
          values[index]["forme_jurdique_benefiser"] = getDetails.forme_juridique;
          values[index]["capital_benefiser"] = getDetails.capital_social;
          values[index]["adresse_benefiser"] = getDetails.adresse_rcs;
          values[index]["code_postal_benefiser"] = getDetails.code_postal;
          values[index]["ville_benefiser"] = getDetails.ville;
          values[index]["ville_benefiserArr"] =getDetails.cityArr;
          values[index]["ville_id_benefiser"] = getDetails.ville_id;
          values[index]["greffe_benefiser"] = getDetails.area;
          setBenefiser(values);
          setFormData(formData => ({ ...formData, ["Benefiser"]: values }));
        }      
      }
      if(type === "rcs_societe"){       
        setFormData(formData => ({ ...formData, ["denomination_societe"]: "",["forme_juridique_societe"]:"",["capital_societe"]:"",["address_societe"]:"",["code_postal"]:"",["ville"]:"",["ville_id"]:"",["villeArr"]:[],["greffe"]:"" }));   
 
        if(value.length>0){
          let getDetails = await getDetailsBySiren(value);    
          setFormData(formData => ({ ...formData, ["denomination_societe"]:getDetails.denomination,["forme_juridique_societe"]:getDetails.forme_juridique,["capital_societe"]:getDetails.capital_social,["address_societe"]:getDetails.adresse_rcs,["code_postal"]:getDetails.code_postal,["ville"]:getDetails.ville,["ville_id"]:getDetails.ville_id,["villeArr"]:getDetails.cityArr,["greffe"]:getDetails.area }));   
        }
      }
    }, 1000);
    return () => clearTimeout(getSiren);
  }
  
  async function getCityFromPostal(name,value,index){
    const getCity = setTimeout(async() => {
      if(name === "code_postal_morale"){
        let values = [...La_gerance];
        values[index]["ville_morale"] = "";
        values[index]["ville_moraleArr"] =[];
        values[index]["ville_id_morale"] = "";
        values[index]["greffe_morale"] = "";
        setLa_gerance(values);
        setFormData(formData => ({ ...formData, ["La_gerance"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){          
            values[index]["ville_morale"] = response.data.data.city;
            values[index]["ville_moraleArr"] =response.data.data.cityArr;
            values[index]["ville_id_morale"] = response.data.data.id;
            values[index]["greffe_morale"] = response.data.data.area;
            setLa_gerance(values);
            setFormData(formData => ({ ...formData, ["La_gerance"]: values }));
          }
        }
      }
      if(name === "code_postal_benefiser"){
        let values = [...Benefiser];
        values[index]["ville_benefiser"] = "";
        values[index]["ville_benefiserArr"] = [];
        values[index]["ville_id_benefiser"] = "";
        values[index]["greffe_benefiser"] = "";
        setBenefiser(values);
        setFormData(formData => ({ ...formData, ["Benefiser"]: values }));     
        if(value.length>0){
          const response = await axios.get(`${process.env.REACT_APP_API_URL}api/checkzipcode/${value}`);
          if( response.data &&  response.data.data){          
            values[index]["ville_benefiser"] = response.data.data.city;
            values[index]["ville_benefiserArr"] = response.data.data.cityArr;
            values[index]["ville_id_benefiser"] = response.data.data.id;
            values[index]["greffe_benefiser"] = response.data.data.area;
            setBenefiser(values);
            setFormData(formData => ({ ...formData, ["Benefiser"]: values }));
          }
        }
      }
            
    }, 1000);
    return () => clearTimeout(getCity);
  }
  async function handleSelectChange(e) {
    // console.log("e",e.target.id)    
    setFormData(formData => ({ ...formData, ["forme_juridique_societeType"]: e.target.id }));

  }
  async function handleChange(e) {
    // console.log("e",e)
    const { name, value } = e.target;    
    if(name == "ville_id"){
      let formDataGet = {...formData};
      let cityArrFilter = formDataGet.villeArr.filter((val,i)=>val.id==value);
      setFormData(formData => ({ ...formData, ["ville"]: cityArrFilter[0].city,["ville_id"]: value }));

    }else{
      setFormData(formData => ({ ...formData, [name]: value }));
    } 

   /*  if(name === "code_postalarrivant" || name === "code_postal_transfer" || name === "code_postal_la_grance"){    
      await getCityFromPostalType(name,value); 
    }  */   

    if(name === "rcs_societe"){
      await getSirenDetailsBySiren(name,value,0,"rcs_societe");
    }
    
  }

  function handleChangeDate(e,name) {
    let newDate = moment(e.$d).format('YYYY/MM/DD');
    setFormData(formData => ({ ...formData, [name]: newDate }));
  }
  
  async function submitPaymentDetails() { 
    let valid  = false;
    // setSubmitted(true);
    setLoading(true);
    delete paymentData['data']['billing_address_json'];
    // delete paymentData['data']['currentUserDetails'];
    delete paymentData['data']['select_cartdetailJ'];
    delete paymentData['data']['select_cartdetailN'];
    delete paymentData['data']['select_department'];
    delete paymentData['data']['votre_annonce_json'];
    delete paymentData['data']['votre_annonce'];
    delete paymentData['data']['billing_address_json_parse'];
    delete paymentData['data']['user_detail'];
    delete paymentData['data']['votre_html'];
    
    let getResponse =  await dispatch(announceActions.updatePayment({announce_id:id,user_id:currentUser && currentUser.data?currentUser.data.id:"",serenite:isCheckedSerenity,paymentData:paymentData})).then((responseData) => {         
      // // // console.log("responseData",responseData)        
      return Promise.resolve(responseData);   
      
    })
    .catch((err) => {         
      return Promise.reject({
          "sucess": false,
          "msg": "Une erreur s'est produite. Veuillez réessayer!",
          "data": "",
          "insertID": ""
      });      
    });
    // setSuccessful(true);
    // // // console.log("getResponse",getResponse);
    setLoading(false);
    if(getResponse.sucess === true){        
      valid = true
    }else{
      valid = false
    }
    return valid;
  }

  async function submitUserDetails() { 
    
    let valid  = false;
    // setSubmitted(true);
    if(userSelectedAddress.email && isValidEmail(userSelectedAddress.email) && userSelectedAddress.telephone && isValidPhoneNumber(userSelectedAddress.telephone)  && ((userSelectedAddress.billing_address_type === "account_address") || (userSelectedAddress.billing_address_type === "another_address" && userSelectedAddress.billing_address_code_postal  && userSelectedAddress.billing_address_ville) || ( userSelectedAddress.billing_address_type === "customer_address" && (userSelectedAddress.billing_address_denomination  ||  userSelectedAddress.billing_address_address  || userSelectedAddress.billing_address_code_postal  || userSelectedAddress.billing_address_ville)) )  ){
      setLoading(true);
      let getResponse =  await dispatch(announceActions.update_user(userSelectedAddress)).then((responseData) => { 
        return Promise.resolve(responseData); 
      })
      .catch((err) => { 
        setLoading(false);        
        return Promise.reject({
            "sucess": false,
            "msg": "Une erreur s'est produite. Veuillez réessayer!",
            "data": "",
            "insertID": ""
        });      
      });
      // setSuccessful(true);
      // // // console.log("getResponse",getResponse);
      setLoading(false); 
      if(getResponse.sucess === true){   
           
        valid = true
      }else{
        valid = false
      }
    }
    
    return valid;
  }
  async function handleSubmit() { 
    let valid  = false;  
    setSuccessful(false);
    setSubmitted(true);
    setSubmitted(true);
    // // // console.log("formData",formData)
   
    if(formData.type_perdecision_acte && formData.date_typeag && formData.date_type_effet && formData.rcs_societe && formData.denomination_societe && formData.forme_juridique_societe && formData.capital_societe && formData.address_societe  && formData.ville  && formData.greffe && (formData.La_gerance.length>0 && formData.La_gerance[0].Personne_typecendant) && (formData.Benefiser.length>0 && formData.Benefiser[0].Personne_benefiser)) {  
      // // console.log("formData",formData)
      let checkLaGerance = await Promise.all(formData.La_gerance.map((val,key)=>{
        var status = false;
        if( val.Personne_typecendant==="PERSONNE_PHYSIQUE" && val.civilite_cendant  && val.nom_cendant && val.prenom_cendant && val.address_morale && ((val.resident_etranger_physique_morale =="Non" && val.code_postal_morale && val.ville_morale)|| (val.resident_etranger_physique_morale =="Oui" && val.pays_morale && val.ville_morale)) ){
          status= true;
        }else if( val.Personne_typecendant==="PERSONNE_MORALE" && val.rcs_cendant  && val.denomination_morale  && val.forme_juridique_morale  && val.capital_morale && val.address_morale && val.code_postal_morale && val.ville_morale  && val.greffe_morale && val.representation_nom_morale && val.representation_prenom_morale ){
          status= true;
        }        
        return status;
      }));  
      let checkBenefiser = await Promise.all(formData.Benefiser.map((val,key)=>{
        var status = false;
        if( val.Personne_benefiser==="PERSONNE_PHYSIQUE" && val.civilite_physique_benefiser  && val.nom_physique_benefiser && val.prenom_physique_benefiser && val.adresse_benefiser && ((val.resident_etranger_physique_benefiser =="Non"  && val.code_postal_benefiser && val.ville_benefiser)|| (val.resident_etranger_physique_benefiser =="Oui" && val.pays_benefiser && val.ville_benefiser)) ){
          status= true;
        }else if( val.Personne_benefiser==="PERSONNE_MORALE" && val.rcs_benefiser  && val.denomination_benefiser  && val.forme_jurdique_benefiser  && val.capital_benefiser && val.adresse_benefiser && val.code_postal_benefiser && val.ville_benefiser  && val.greffe_benefiser && val.representation_nom_benefiser && val.representation_prenom_benefiser ){
          status= true;
        }        
        return status;
      }));    
      if(!checkLaGerance.includes(false) && (!checkBenefiser.includes(false)) && formData.nomber_departs  && formData.motantdelacession) {
        valid = true;
      }else{
        valid = false;
      }
      // valid= !checkLaGerance.includes(false);
      // valid = true;
    } 
    /* // // console.log("valid",valid)
    return false;   */ 
    if(valid === true){
      setLoading(true);
      // // // console.log("formData",formData)
      let getResponse =  await dispatch(announceActions.create(formData)).then((responseData) => { 
        announceIdRef.current = responseData.announce_id;         
        // // // console.log("responseData",responseData)        
        return Promise.resolve(responseData);   
        
      })
      .catch((err) => { 
        // // // console.log("responseData err",err) 
        setLoading(false);          
        return Promise.resolve({
            "sucess": false,
            "msg": "Une erreur s'est produite. Veuillez réessayer!",
            "data": "",
            "insertID": ""
        });      
      });
      setSuccessful(true);
      if(getResponse.sucess === true){        
        valid = true
      }else{
        valid = false
      }
    }
    
    return valid;
   
}
  function setPaymentDataFunc(data){
    setPaymentData(data);
  }

  const handlePayment =async () => {    
    if(!currentUser){
      navigate("/login");
    }
  };
  function getStepContent(step) {
    switch (step) {
      case 0: 
      return <CessionPartsSociales adsname={adsname.toUpperCase()} formData={formData} La_gerance={La_gerance} Benefiser={Benefiser} handleChange={handleChange} handleSelectChange={handleSelectChange} handleChangeDate={handleChangeDate} isSubmitted={isSubmitted}   handleChangeAddForm={handleChangeAddForm}  />;        
      case 1:
        return <FormSummary  handleBack={handleBack} adsname={adsname.toUpperCase()}  />;
      case 2:
        return <CompleteAddress setUserSelectedAddress={setUserSelectedAddress} userSelectedAddress={userSelectedAddress}   adsname={adsname.toUpperCase()}  />;
      case 3:
        return <PaymentForm setPaymentDataFunc={setPaymentDataFunc} isCheckedSerenity={isCheckedSerenity} setIscheckedSerenity={setIscheckedSerenity} setis_general_conditions_sale={setis_general_conditions_sale} is_general_conditions_sale={is_general_conditions_sale} general_conditions_sale_msg={general_conditions_sale_msg} adsname={adsname.toUpperCase()} />;
      case 4:
       /*  return announceDetails&&announceDetails.data&&parseInt(announceDetails.data.status)===3?<FormSuccess announceDetails={announceDetails} />: activeStep===4?<Elements options={options} stripe={stripePromise}><PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment}  adsname={adsname.toUpperCase()} /> </Elements>:<PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment}  adsname={adsname.toUpperCase()} />; */
        return activeStep===4?<Elements options={options} stripe={stripePromise}><PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment} setLoading={setLoading}  adsname={adsname.toUpperCase()} /> </Elements>:<PaymentSecond ref={childRef} payamentPrice={payamentPrice} handlePayment={handlePayment} setLoading={setLoading} adsname={adsname.toUpperCase()} />;

      default:
        return 'Unknown step';
    }
  }
  
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
 

  const handleSaveAnnonce = async () => {
    setSuccessful(false)
    setLoadingFullpage(true);
    localStorage.setItem("activeStep",activeStep);
    if(!currentUser){
      navigate("/login");
      return;
    }
    try {
      const requestData = {
        announce_id: id,
        user_id: currentUser && currentUser.data?currentUser.data.id:"",
      };
      let post_url = `${process.env.REACT_APP_API_URL}api/announce/save_announce`;

      // Use Axios to make the API request
      const response = await axios.post(post_url, requestData, {
        headers: {
            'Content-Type': 'application/json',
        },
      });
      setLoadingFullpage(false);
      setSuccessful(true)
      if(response.data.sucess === true){
        navigate("/userdashboard/annonces-en-attente");
      }else{
        dispatch(alertActions.error("Une erreur s'est produite. Veuillez réessayer!")); 
      }
      
      // return {success:true,data:response.data}
    } catch (error) {
      setLoadingFullpage(false);
      setSuccessful(true)
      dispatch(alertActions.error("Une erreur s'est produite. Veuillez réessayer!"));
      // // console.log(error); 
      // return {success:false,data:""}     
    }
  }
  const handleNext = async (activeStepGet) => {
    // // console.log("activeStepGet",activeStepGet)
    
    let submitResult = true;
    if(!currentUser && activeStepGet !== 0 && (!localStorage.getItem("fromAdmin"))){
      navigate("/login");
    }
    if(activeStepGet === 0){
      submitResult = await handleSubmit();
      // // console.log("submitResult",submitResult)
      
    }
    if(activeStepGet === 2){
      submitResult = await submitUserDetails();

    }
    if(activeStepGet === 3){
      setgeneral_conditions_sale_msg("");
      if(!is_general_conditions_sale){
        setgeneral_conditions_sale_msg("Veuillez accepter les conditions générales de vente")
        return false;
      }
      submitResult = await submitPaymentDetails();

    }
    if(submitResult){
      setLoading(false);     
      if(currentUser && currentUser.UserProDetails && currentUser.UserProDetails.details && currentUser.UserProDetails.details.payment_plan && currentUser.UserProDetails.details.payment_plan.includes("monthly") && activeStepGet === 3){
        navigate(location.pathname+"?activstep=5");

      }
      else if(localStorage.getItem("fromAdmin") && activeStepGet === 1 && announceData && announceData.data && announceData.data.status==='3')
      {
        const idString = String(announceData.data.id).padStart(8, '0');
        let invoice_number = moment().format("DDMMY")+"_"+idString;
        let data = {
          "announce_id":announceData.data.id,
          "payment_order_id":invoice_number,
          "invoice_number":invoice_number,
          "invoice_date":moment().format("DD-MM-Y"),
          "date_payment":moment().format("DD-MM-Y"),
          "payment_intent":invoice_number,
          "payment_price":announceData.data.total,
          "payment_intent_client_secret":"",
        }
        const update_response = await updateAnnouncePayment(data);
        dispatch(alertActions.success("Données mises à jour avec succès !!"));
        setSuccessful(true)
        setTimeout(() => {
          setSuccessful(false)
          localStorage.removeItem("fromAdmin")
          navigate("/admin/devis");
        }, 1000);
      }
      else{
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);  
        if(location.pathname.split('/').length ===4){
          navigate(location.pathname+"/"+announceIdRef.current);
        }
      }
    }else{
      // let newSkipped = skipped;
      // if (isStepSkipped(activeStep)) {
      //   newSkipped = new Set(newSkipped.values());
      //   newSkipped.delete(activeStep);
      // }
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
      // setSkipped(newSkipped);
    }
    
  };
  const handleBack = () => {
    if(id || announceData.announce_id){
      // // // console.log("location",location);
      // // // console.log("location.pathname",location.pathname.split('/'));  
      setActiveStep((prevActiveStep) => prevActiveStep - 1);   
      if(location.pathname.split('/').length ===4){
        navigate(location.pathname+"/"+announceData.announce_id);
      }
      

    }else{
      setActiveStep((prevActiveStep) => prevActiveStep - 1);

    }
  };
  

  
async function updateAnnouncePayment(bodyData){
  setLoadingFullpage(true);
  try {
    let getResponse =  await dispatch(announceActions.updateSuccessPayment(bodyData)).then((responseData) => {       
      
      if(responseData.sucess == true){
        setAnnounceDetails(responseData);
        let announce = {
          "data":responseData.data,
          "announce_id":bodyData.announce_id 
        }
        dispatch({ type: announceConstants.CREATE_SUCCESS, announce});
      }
      setLoadingFullpage(false);      
      return Promise.resolve(responseData);   
      
    })
    .catch((err) => {
      setLoadingFullpage(false);           
      return Promise.reject({
          "sucess": false,
          "msg": "Une erreur s'est produite. Veuillez réessayer!",
          "data": "",
          "insertID": ""
      });      
    });
   /* return {success:true,data:response.data} */ 
  } catch (error) {
    // // console.log(error); 
    return {success:false,data:""}     
  }
}
  
async function getAnnounceDetails(announce_id){
  setLoadingFullpage(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}api/announce/announce/${announce_id}`);
    
    if(response.data.sucess === true){
       if(!localStorage.getItem("fromAdmin") && (parseInt(response.data.data.status) === 3 || (response.data.data.length<=0))){
       navigate("/");
      }
      let announce = response.data;
      dispatch({ type: announceConstants.UPDATE_SUCCESS, announce });
      setAnnounceDetails(response.data);
    }
    setLoadingFullpage(false);
    return {success:true,data:response.data}
  } catch (error) {
    setLoadingFullpage(false);
    // // console.log(error); 
    return {success:false,data:""}     
  }
}

  
  return (
    <>
     {loadingFullpage?
      <PageLoaderComp />
      :""}
    
     {successful?
      <ToastMessageComp  message={alert.message} type={alert.type} />
      :""}
      
      <div className='bg-mainBg'>
        <div className='md:max-w-[1477px] relative w-full h-full m-auto py-7 px-4 sm:px-14 myForm'>
          <Breadcrumb Accueil="Accueil" page={(ads.split("-")).join(" ")} />
            
          <div className='relative  bg-mainBg my-4 sm:my-12 '>
            <div className='grid grid-cols-12 gap-5  '>
              <div className='mb-8 col-span-12 2lg:col-span-8'>
                <div className='hidden sm:inline-flex bg-white  mb-6 items-center justify-between w-full max-w-[974px] h-[81px] rounded-md xl:px-12  '>
                  <Stepper activeStep={queryParameters.get("activstep")?queryParameters.get("activstep"):activeStep} className='w-full  '>
                    {steps.map((label, index) => {
                      return (
                        <Step key={label}  >
                          <StepLabel>
                            <div className='inline-flex   items-center justify-between w-full'> 
                              <div className='max-w-[118px] text-black-light font-normal'>{label}</div>
                            </div>
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </div>
                
                <div className='bg-white max-w-[974px] rounded-xl  ' style={{ border: '0.5px solid #DEE3E2' }}>
                  {queryParameters.get("activstep") && parseInt(queryParameters.get("activstep")) === steps.length ? (
                    <>
                      <Typography sx={{ mt: 2, mb: 1 }}>
                        <FormSuccess announceDetails={announceDetails} loadingFullpage={loadingFullpage} />
                      </Typography>
                      
                    </>
                  ) : (
                    <>
                      <Typography  >{getStepContent(activeStep)}</Typography>
                      {
                       <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>                     
                      <button onClick={handleBack} className={activeStep === 0 ?"hidden":"w-48 h-12 m-4 rounded-md bg-thColor font-extrabold text-base sm:text-lg 3xl:text-xl text-white transition-all duration-300 hover:bg-secondary hover:btnShadow"} >
                        Précédent
                      </button>
                      <Box sx={{ flex: '1 1 auto' }} />
                      {/* onClick={() => childRef.current.getAlert()} */}
                      {/* handlePayment() */}
                      <button onClick={handleSaveAnnonce} className={!fromAdmin && activeStep === 1 ?"w-48 h-12 m-4 rounded-md bg-secondary font-extrabold text-base sm:text-lg 3xl:text-xl text-white transition-all duration-300 hover:bg-thColor hover:btnShadow":"hidden"} >
                        Enregistrer
                      </button>
                      <button disabled={loading?true:false} style={{"opacity":loading?"0.7":""}} onClick={()=>activeStep === steps.length - 1 ? childRef.current.handleSubmitCheckout():handleNext(activeStep)} className='w-48 h-12 m-4 rounded-md bg-thColor font-extrabold text-base sm:text-lg 3xl:text-xl text-white transition-all duration-300 hover:bg-secondary hover:btnShadow'>
                          {activeStep === steps.length - 1 ? `Payer ${payamentPrice} €` : activeStep ===0 ?'Obtenir le tarif':'Etape suivante '} 
                          {
                            loading?                         
                            <CircularProgress 
                            size={24}
                            sx={{
                              color: "white",
                              // marginTop: '-10px',
                              /* position: 'absolute',
                              top: '50%',
                              left: '50%',
                              
                              marginLeft: '-12px', */
                            }} />
                        :""}
                      </button>
                    </Box>
                    }
                    </>
                  )}
                </div>
              </div>
              <div className=' col-span-12 2lg:col-span-4  '>
                <Procedures />
                <Express />
                <PaymentSideBlock />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div >
    </>
  );
}


